import { SidebarBoxKey } from 'AdmissionsGuidance';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'Text';
import { parseHtml } from 'FrontRoyalAngular/html.utils';
import { useNavigationHelper } from 'FrontRoyalAngular';
import { BasicDesktopBox } from '../../BasicDesktopBox';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';

const INTERNATIONAL_TRACKING_URL = 'https://shop.quantic.edu/products/courier-express-diploma-shipping';

type Props = {
    userName: string;
    mailingAddress: string;
};

export function DiplomaCheckBoxComponent({ userName, mailingAddress }: Props) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'diplomaCheckBox' });
    const { loadRoute, loadUrl } = useNavigationHelper();
    const buttons = useMemo<ButtonConfig[]>(
        () => [
            {
                id: 'button_update_name',
                text: t('buttonUpdateName'),
                onPress: () => {
                    loadRoute('/settings/account');
                },
            },
            {
                id: 'button_update_address',
                text: t('buttonUpdateAddress'),
                onPress: () => {
                    loadRoute('/settings/documents');
                },
            },
            {
                id: 'button_add_international_tracking',
                text: t('buttonInternationalTracking'),
                onPress: () => {
                    loadUrl(INTERNATIONAL_TRACKING_URL, '_blank');
                },
                className: 'mt-5',
            },
        ],
        [t, loadRoute, loadUrl],
    );

    return <DiplomaCheckBoxPresentation userName={userName} mailingAddress={mailingAddress} buttons={buttons} />;
}

export function DiplomaCheckBoxPresentation({
    userName,
    mailingAddress,
    buttons,
}: {
    userName: string;
    mailingAddress: string;
    buttons: ButtonConfig[];
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'diplomaCheckBox' });
    return (
        <BasicDesktopBox boxKey={SidebarBoxKey.diploma_check} headerText={t('heading')} buttons={buttons}>
            <Text weight="semibold" className="mb-3">
                <Text as="div" uppercase>
                    {userName}
                </Text>
                <Text as="div">{parseHtml(mailingAddress)}</Text>
            </Text>
            <Text>{t('content')}</Text>
        </BasicDesktopBox>
    );
}

export const DiplomaCheckBox = memo(DiplomaCheckBoxComponent) as typeof DiplomaCheckBoxComponent;
